const colors = {
  primary: {
    50: '#ffe4e8',
    100: '#fbb9bf',
    200: '#f38d94',
    300: '#ec606b',
    400: '#e53341',
    500: '#cc1a27',
    600: '#9f121d',
    700: '#720a15',
    800: '#47050a',
    900: '#1f0000',
  },
}

export default colors
